<app-page-content>
<app-doenkids-menu-bar
  menuBar
  [showBackButton]="true"
  [backUrl]="backUrl"
></app-doenkids-menu-bar>

<div content>
  <mat-toolbar class="doenkids-toolbar">
  <h2>
    {{ 'insights_program_status_program_list.title' | translate: {
    organizationUnitName: ouName,
    status: ('program.status.' + programStatusName) | translate
    } }}
  </h2>
</mat-toolbar>

<mat-card appearance="outlined">
  @if (list) {
    <mat-list>
      @for (item of list | paginate: {
        id: 'insightsProgramStatusList',
        itemsPerPage: MAX_ITEMS_PER_PAGE,
        currentPage: currentPage,
        totalItems: list.length
        }; track item) {
        <mat-list-item (click)="navigate(item.id)">
          <mat-icon matListItemIcon>calendar_today</mat-icon>
          <div matListItemTitle> {{ item.name }}</div>
          <div matListItemLine> {{ item.from | i18n_date | async }} - {{ item.to | i18n_date | async }} </div>
        </mat-list-item>
      }
    </mat-list>
  }
  @if (list && list.length > MAX_ITEMS_PER_PAGE) {
    <div class="flex-row justify-center items-center">
      <pagination-controls
        id="insightsProgramStatusList"
        [nextLabel]="'generic.pagination.next' | translate"
        [previousLabel]="'generic.pagination.previous' | translate"
        (pageChange)="paginate($event)"
      ></pagination-controls>
    </div>
  }
</mat-card>
</div>
</app-page-content>
